export const H5_ROUTES = ['/warning/detail', '/warning/list'];
